import React, { Component } from 'react'
import avatar from './speakers_avatars/avatar.svg'
import paul from './speakers_avatars/paul.svg'
import han from './speakers_avatars/han.svg'
import alan from './speakers_avatars/alan.svg'
import { getSpeakers } from "../../../fetcher";
import './Speaker.css'

export default class Speaker extends Component {
    constructor(props){
        super(props)
        this.state = { 
            speakerLists:[
            ],
           
        }
    }

    componentDidMount() {
        this.fetchSpeakerData();
      }

    fetchSpeakerData = async () => {
        try {
          const speakerData = await getSpeakers();
          let speakerList=[]
        //   console.log(speakerData)
          speakerData.records?.forEach((speakerContentElement, index) => {
            const speaker = speakerData.records[index].fields;
            let id = index
            let name = speaker.Name;
            let company = speaker.Company
            let position=speaker.Position
            let photo = speaker.Photo[0].url
            let speakerDetail = {id:id, name: name, company: company, position: position, photo: photo}
            speakerList.push(speakerDetail)
          });

          this.setState({speakerLists:speakerList})
          

        } catch (error) {
          console.error(error);
        }
      };

      

  render() {
    let SpeakerList = this.state.speakerLists.map(item=>{
        return (
        <div className='speaker-newList-one' key={item.id}>
           <div className='speaker_content'>
                <div className='speaker_avatar_container'>
                    <img className='speaker_avatar' src={avatar} alt="pic" />
                    <img className='speaker_pic' src={item.photo} alt="pic" />
                </div>
                <h1 className='speaker_name'>{item.name}</h1>
                <h4 className='speaker_position'>{item.position}</h4>
                <h4 className='speaker_company'>{item.company}</h4>
            </div>
        </div>)
    })
    return (
      <div className='speaker'>
        <div className='speaker_title'>
            <h1 className='speaker_title_text'>Our Speakers</h1>
            <hr className='speaker_hr'/>
        </div>
        <div className='speaker_container'>
            {SpeakerList}
            {/* <div className='speaker_content'>
                <div className='speaker_avatar_container'>
                    <img className='speaker_avatar' src={avatar} alt="pic" />
                    <img className='speaker_pic' src={paul} alt="pic" />
                </div>
                <h1 className='speaker_name'>Paul Chapman</h1>
                <h4 className='speaker_position'>VP & Global CIO</h4>
                <h4 className='speaker_company'>@Box</h4>
            </div>
            <div className='speaker_content'>
                <div className='speaker_avatar_container'>
                    <img className='speaker_avatar' src={avatar} alt="pic" />
                    <img className='speaker_pic' src={han} alt="pic" />
                </div>
                <h1 className='speaker_name' left='-10px'>Han-Shen(Han) Yuan</h1>
                <h4 className='speaker_position'>EX-Senior VP of</h4>
                <h4 className='speaker_position'>Engineering</h4>
                <h4 className='speaker_company'>@Upwork</h4>
            </div>
            <div className='speaker_content'>
                <div className='speaker_avatar_container'>
                    <img className='speaker_avatar' src={avatar} alt="pic" />
                    <img className='speaker_pic' src={alan} alt="pic" />
                </div>
                <h1 className='speaker_name'>Alan Wang</h1>
                <h4 className='speaker_position'>Founder @Alan Wang</h4>
                <h4 className='speaker_company'>Realty Group</h4>
            </div>
            <div className='speaker_content'>
                <div className='speaker_avatar_container'>
                    <img className='speaker_avatar' src={avatar} alt="pic" />
                    <img className='speaker_pic' src={paul} alt="pic" />
                </div>
                <h1 className='speaker_name'>Paul Chapman</h1>
                <h4 className='speaker_position'>VP & Global CIO</h4>
                <h4 className='speaker_company'>@Box</h4>
            </div>
            <div className='speaker_content'>
                <div className='speaker_avatar_container'>
                    <img className='speaker_avatar' src={avatar} alt="pic" />
                    <img className='speaker_pic' src={paul} alt="pic" />
                </div>
                <h1 className='speaker_name'>Paul Chapman</h1>
                <h4 className='speaker_position'>VP & Global CIO</h4>
                <h4 className='speaker_company'>@Box</h4>
            </div>
        </div>
        <div className='speaker_container'>
            <div className='speaker_content'>
                <div className='speaker_avatar_container'>
                    <img className='speaker_avatar' src={avatar} alt="pic" />
                    <img className='speaker_pic' src={paul} alt="pic" />
                </div>
                <h1 className='speaker_name'>Paul Chapman</h1>
                <h4 className='speaker_position'>VP & Global CIO</h4>
                <h4 className='speaker_company'>@Box</h4>
            </div>
            <div className='speaker_content'>
                <div className='speaker_avatar_container'>
                    <img className='speaker_avatar' src={avatar} alt="pic" />
                    <img className='speaker_pic' src={paul} alt="pic" />
                </div>
                <h1 className='speaker_name'>Paul Chapman</h1>
                <h4 className='speaker_position'>VP & Global CIO</h4>
                <h4 className='speaker_company'>@Box</h4>
            </div>
            <div className='speaker_content'>
                <div className='speaker_avatar_container'>
                    <img className='speaker_avatar' src={avatar} alt="pic" />
                    <img className='speaker_pic' src={paul} alt="pic" />
                </div>
                <h1 className='speaker_name'>Paul Chapman</h1>
                <h4 className='speaker_position'>VP & Global CIO</h4>
                <h4 className='speaker_company'>@Box</h4>
            </div>
            <div className='speaker_content'>
                <div className='speaker_avatar_container'>
                    <img className='speaker_avatar' src={avatar} alt="pic" />
                    <img className='speaker_pic' src={paul} alt="pic" />
                </div>
                <h1 className='speaker_name'>Paul Chapman</h1>
                <h4 className='speaker_position'>VP & Global CIO</h4>
                <h4 className='speaker_company'>@Box</h4>
            </div>
            <div className='speaker_content'>
                <div className='speaker_avatar_container'>
                    <img className='speaker_avatar' src={avatar} alt="pic" />
                    <img className='speaker_pic' src={paul} alt="pic" />
                </div>
                <h1 className='speaker_name'>Paul Chapman</h1>
                <h4 className='speaker_position'>VP & Global CIO</h4>
                <h4 className='speaker_company'>@Box</h4>
            </div>
        </div>
        <div className='speaker_container'>
            <div className='speaker_content'>
                <div className='speaker_avatar_container'>
                    <img className='speaker_avatar' src={avatar} alt="pic" />
                    <img className='speaker_pic' src={paul} alt="pic" />
                </div>
                <h1 className='speaker_name'>Paul Chapman</h1>
                <h4 className='speaker_position'>VP & Global CIO</h4>
                <h4 className='speaker_company'>@Box</h4>
            </div>
            <div className='speaker_content'>
                <div className='speaker_avatar_container'>
                    <img className='speaker_avatar' src={avatar} alt="pic" />
                    <img className='speaker_pic' src={paul} alt="pic" />
                </div>
                <h1 className='speaker_name'>Paul Chapman</h1>
                <h4 className='speaker_position'>VP & Global CIO</h4>
                <h4 className='speaker_company'>@Box</h4>
            </div>
            <div className='speaker_content'>
                <div className='speaker_avatar_container'>
                    <img className='speaker_avatar' src={avatar} alt="pic" />
                    <img className='speaker_pic' src={paul} alt="pic" />
                </div>
                <h1 className='speaker_name'>Paul Chapman</h1>
                <h4 className='speaker_position'>VP & Global CIO</h4>
                <h4 className='speaker_company'>@Box</h4>
            </div>
            <div className='speaker_content'>
                <div className='speaker_avatar_container'>
                    <img className='speaker_avatar' src={avatar} alt="pic" />
                    <img className='speaker_pic' src={paul} alt="pic" />
                </div>
                <h1 className='speaker_name'>Paul Chapman</h1>
                <h4 className='speaker_position'>VP & Global CIO</h4>
                <h4 className='speaker_company'>@Box</h4>
            </div>
            <div className='speaker_content'>
                <div className='speaker_avatar_container'>
                    <img className='speaker_avatar' src={avatar} alt="pic" />
                    <img className='speaker_pic' src={paul} alt="pic" />
                </div>
                <h1 className='speaker_name'>Paul Chapman</h1>
                <h4 className='speaker_position'>VP & Global CIO</h4>
                <h4 className='speaker_company'>@Box</h4>
            </div> */}
        </div>
      </div>
    )
  }
}